const footerColumns = [
  {
    title: "逛内容",
    links: [
      { label: "新品速递", href: "#new-arrivals" },
      { label: "周边测评", href: "#reviews" },
      { label: "手办资料库", href: "#database" },
      { label: "新手指南", href: "#guide" },
    ],
  },
  {
    title: "泡社区",
    links: [
      { label: "论坛热帖", href: "#forum" },
      { label: "晒物专区", href: "#forum" },
      { label: "交易区", href: "#forum" },
      { label: "同好口碑", href: "#forum" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于 78动漫", href: "#top" },
      { label: "内容投稿", href: "#reviews" },
      { label: "资料库提交", href: "#database" },
      { label: "社区规则", href: "#forum" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-diamond-line text-lg" />
              </span>
              <strong className="font-heading text-lg font-bold text-foreground-950">78动漫</strong>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个围着模型手办转的玩家社区。看周边测评、查资料库、泡论坛聊同好，
              从选品到晒物，都在这里完成。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="#download"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                <i className="ri-apple-fill" />
                App Store
              </a>
              <a
                href="#download"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-android-fill" />
                Android 版
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 78动漫 · 模型手办社区 · 本站为演示站点，内容仅供展示</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-accent-600" />
              内容仅供参考
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-map-pin-line" />
              上海 · 玩家共建
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}